module.exports = __webpack_public_path__ + "static/media/snith_core.7a3c8eec.jpeg";